<template>
  <div class="m-card-wrapper">
    <router-link :to="route" v-if="route">
      <div class="m-card">
        <div class="m-card__body">
          <div class="m-card__body-head">
            <img src="@/assets/images/icons_new/OSC_Dokumente.svg" />
          </div>
          <div class="m-card__body-footer">
            <div class="bold">{{ title }}</div>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'CardFair',
  props: {
    title: {
      type: String,
      default: '',
      required: true
    },
    code: {
      type: String,
      default: '',
      required: true
    },
    fairCode: {
      type: String,
      default: '',
      required: true
    }
  },
  computed: {
    route() {
      return {
        name: 'PastFairs',
        params: {
          series: this.code,
          fair: this.fairCode
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';

$color-main: rgba(255, 255, 255, 0.3);
$color-renew: #4187ba;
$color-closed: rgba(255, 255, 255, 0.3);

@mixin setBgColorAndHover($color) {
  background-color: $color;

  &:hover {
    background-color: darken($color, 20%);
    cursor: pointer;
  }
}

.m-card-wrapper {
  a {
    text-decoration: none;
  }
}

.m-card {
  width: 100%;
  border-radius: 0;
  color: black;
  transition: all .2s ease-in-out;

  &:hover {
    transform: scale(1.1);
  }

  @media (min-width: 1358px) {
    width: 294px;
  }

  &__body {
    padding: 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    text-align: center;

    h2 {
      font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
      font-size: $card-title-font-size;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.43;
      letter-spacing: 0.6px;
      color: #ffffff;
      margin-bottom: 0;
    }

    &-content {
      font-size: $card-text-font-size;
      font-weight: 300;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.67;
      letter-spacing: 0.6px;
    }

    &-footer {
      padding-top: 0.5rem;
      text-align: center;
    }
  }

  &.closed {
    height: 170px;
    @include setBgColorAndHover($color-closed);
    .m-card__body {
      &-footer {
        > img:first-child {
          opacity: 0;
        }
      }
    }
  }
}
</style>
